import apiClient from './apiClient';

export const createLanguage = async (payload) => {
  try {
    const response = await apiClient.post("admin/languages/create", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error creating language:", error);
    throw error;
  }
};

export const getAllLanguages = async (page, per_page) => {
  try {
    const response = await apiClient.get(`admin/languages/get-all-language?page=${page}&per_page=${per_page}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error getting languages:", error);
    throw error;
  }
};

export const updateLanguage = async (id, payload) => {
  try {
    const response = await apiClient.put(`admin/languages/${id}`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error updating language:", error);
    throw error;
  }
};

export const deleteLanguage = async (id) => {
  try {
    const response = await apiClient.delete(`admin/languages/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error deleting language:", error);
    throw error;
  }
};